/*
 *
 * PlanSelection actions
 *
 */

import * as actionTypes from './constants'

export function createFolder(
  name,
  parentId,
  projectId,
  planIndex,
  retries = 1
) {
  return {
    type: actionTypes.CREATE_FOLDER,
    name,
    parentId,
    projectId,
    planIndex,
    retries
  }
}

export function folderCreated(folder) {
  return {
    type: actionTypes.FOLDER_CREATED,
    folder
  }
}

export function createFolderError(error) {
  return {
    type: actionTypes.CREATE_FOLDER_ERROR,
    error
  }
}

export function clearCreateFolder() {
  return {
    type: actionTypes.CLEAR_CREATE_FOLDER
  }
}

export function setProjectName(projectName) {
  return {
    type: actionTypes.SET_PROJECT_NAME,
    projectName
  }
}

export function checkCanCreatePlan(retries = 1) {
  return {
    type: actionTypes.CHECK_CAN_CREATE_PLAN,
    retries
  }
}
export function checkCanCreatePlanDone(canCreatePlan) {
  return {
    type: actionTypes.CHECK_CAN_CREATE_PLAN_DONE,
    canCreatePlan
  }
}
export function checkCanCreatePlanError(error) {
  return {
    type: actionTypes.CHECK_CAN_CREATE_PLAN_ERROR,
    error
  }
}

export function clearPlans() {
  return {
    type: actionTypes.CLEAR_PLANS
  }
}
export function clearFolderPlans(folderId) {
  return {
    type: actionTypes.CLEAR_FOLDER_PLANS,
    folderId
  }
}
export function getRootPlans(
  projectId,
  page,
  sort,
  stateFilter,
  search,
  refresh,
  sortDirection,
  retries = 1
) {
  return {
    type: actionTypes.GET_ROOT_PLANS,
    projectId,
    page,
    sort,
    stateFilter,
    search,
    refresh,
    sortDirection,
    retries
  }
}
export function getRootPlansDone(plans, timestamp, cached) {
  return {
    type: actionTypes.GET_ROOT_PLANS_DONE,
    plans,
    cached,
    timestamp
  }
}
export function getRootPlansError(error) {
  return {
    type: actionTypes.GET_ROOT_PLANS_ERROR,
    error
  }
}
export function getRootPlansWithFolders(
  projectId,
  page,
  sort,
  stateFilter,
  search,
  refresh,
  retries = 1
) {
  return {
    type: actionTypes.GET_ROOT_PLANS_WITH_FOLDERS,
    projectId,
    page,
    sort,
    stateFilter,
    search,
    refresh,
    retries
  }
}
export function getRootPlansWithFoldersDone(rootPlans, folders) {
  return {
    type: actionTypes.GET_ROOT_PLANS_WITH_FOLDERS_DONE,
    rootPlans,
    folders
  }
}
export function getRootPlansWithFoldersError(error) {
  return {
    type: actionTypes.GET_ROOT_PLANS_WITH_FOLDERS_ERROR,
    error
  }
}
export function getFolderPlans(folderId, page, refresh, retries = 1) {
  return {
    type: actionTypes.GET_FOLDER_PLANS,
    folderId,
    page,
    refresh,
    retries
  }
}
export function getFolderPlansDone(folderId, plans, timestamp, cached) {
  return {
    type: actionTypes.GET_FOLDER_PLANS_DONE,
    folderId,
    plans,
    cached,
    timestamp
  }
}
export function getFolderPlansError(folderId, error) {
  return {
    type: actionTypes.GET_FOLDER_PLANS_ERROR,
    error,
    folderId
  }
}
